/** Titre attribué par défaut à un projet. */
export const DEFAULT_PROJECT_TITLE = 'Titre du projet';

/** Longueur maximale du titre d'un projet, en caractères. */
export const PROJECT_TITLE_MAX_LENGTH = 255;

/** Retourne le titre sans espaces superflus, ou {@link DEFAULT_PROJECT_TITLE} s'il est vide. */
export const normalizeProjectTitle = (title: string | null | undefined): string => {
  const trimmedTitle = title?.trim();
  if (!trimmedTitle) {
    return DEFAULT_PROJECT_TITLE;
  }

  return trimmedTitle.slice(0, PROJECT_TITLE_MAX_LENGTH);
};
